import React from "react";
import { motion } from 'framer-motion';
const PostCard = ({ item }) => {
  const excerptData = item.excerpt;
  return (
    <motion.div
      key="div0"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      transition={{ duration: 0.7 }}>
      <div className="post-card">
        {item.imgUrl ? (
          <img
            src={item.imgUrl}
            alt={item.imgAlt}
          />
        ) :
          <div className="blank-img" />}
        <div className="body-content">
          <h3>{item.title}</h3>
          <div className="metadata">
            <div className="post-meta">
              <p>{item.date}</p>
            </div>
            {item.excerpt.length > 6 &&
              <div className="excerpt">
                {truncateString(excerptData)}
              </div>}
          </div>
        </div>
      </div>
    </motion.div>
  );
}


const truncateString = (str) => {
  if (str.length > 150) {
    return str.slice(0, 150) + " 。。。";
  }
  return str;
}

export default PostCard;